import { Typography } from 'app/component-library-wave';
import { useTranslation } from 'react-i18next';
import { NetworkMenuItem } from '../network-menu-item';
import { useAppNavigation } from 'app/utils/navigation-utils';
import { areBandsIdentical } from 'app/pages/internet/network-common';
import { navigationService } from 'app/service/navigation/navigation-service';
import { useAppSelector } from 'app/hooks/redux-thunk';
import { useEffect, useState } from 'react';
import { getDataLayers } from 'app/utils/trackingService';
import { getAnonymizedCurrentPageUrl, GtmElementCta } from 'app/utils/gtm-tracking-utils';

interface Props {
  networkData: MinesiderBackend.CustomerNetwork;
  wifiIds: string[];
}

export const CombinedBand = ({ networkData, wifiIds }: Props) => {
  const { t } = useTranslation();

  // CSR = Customer Service Representative
  const { isCsr } = useAppSelector((state) => state.auth);

  const { goToPath } = useAppNavigation();
  const [isCombined, setIsCombined] = useState(areBandsIdentical(networkData, networkData.hgw.wifiSettings));

  useEffect(() => {
    setIsCombined(areBandsIdentical(networkData, wifiIds));
  }, [networkData]);

  if (wifiIds.length === 1) {
    return null;
  }

  const canSplitWifiSettings = networkData.wifiSettings.length > 1 && !networkData.hgw.bridge;

  if (!canSplitWifiSettings || isCsr) {
    return null;
  }

  const handleClick = () => {
    getDataLayers().customEvents.pushButtonClickEvent({
      page_url: getAnonymizedCurrentPageUrl(),
      element_cta: GtmElementCta.INTERNET_SETTINGS_SSID_COMBINED_BAND,
      element_url: navigationService.PAGES.internetSettingsWifiBand.url,
    });
    goToPath(navigationService.getCombineBandUrl(wifiIds));
  };

  return (
    <NetworkMenuItem
      menuText={t('pages.network.advanced.wifi.bandHeader')}
      actionElement={isCombined ? t('pages.network.advanced.wifi.combined') : t('pages.network.advanced.wifi.combine')}
      helpTextHeader={t('pages.network.advanced.wifi.helpTexts.band.title')}
      onClick={handleClick}
    >
      <Typography variant="paragraph3" component="p">
        {t('pages.network.advanced.wifi.helpTexts.band.paragraph1')}
      </Typography>
    </NetworkMenuItem>
  );
};
